import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { ArrowRight, Loader2 } from 'lucide-react';
import { submitEvaluation } from '../utils/mock';
import { toast } from 'sonner';

const ApplicationSection = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    currentClub: '',
    position: 'goalkeeper',
    birthDate: '',
    nationality: '',
    experience: '',
    objectives: '',
    achievements: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const result = await submitEvaluation(formData);
      toast.success('¡Evaluación enviada exitosamente! Nos pondremos en contacto pronto.');
      
      // Reset form
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        currentClub: '',
        position: 'goalkeeper',
        birthDate: '',
        nationality: '',
        experience: '',
        objectives: '',
        achievements: ''
      });
    } catch (error) {
      toast.error('Error al enviar la evaluación. Por favor intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="application" className="application-section section-container">
      <div className="section-header">
        <h2 className="section-title">Aplicar</h2>
      </div>

      <div className="application-content">
        <div className="application-intro">
          <p className="application-text">
            Cada proceso comienza con una evaluación privada.
          </p>

          <div className="application-criteria">
            <h3>Analizamos:</h3>
            <ul>
              <li>Trayectoria</li>
              <li>Proyección</li>
              <li>Perfil competitivo</li>
              <li>Objetivos internacionales</li>
            </ul>
          </div>

          <p className="application-note">
            Solo trabajamos con arqueros alineados con nuestra visión.
          </p>
        </div>

        <div className="application-form-container">
          <form onSubmit={handleSubmit} className="application-form">
            <div className="form-grid">
              <div className="form-group">
                <Label htmlFor="fullName">Nombre Completo *</Label>
                <Input
                  id="fullName"
                  name="fullName"
                  type="text"
                  required
                  value={formData.fullName}
                  onChange={handleInputChange}
                  placeholder="Tu nombre completo"
                />
              </div>

              <div className="form-group">
                <Label htmlFor="email">Email *</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="tu@email.com"
                />
              </div>

              <div className="form-group">
                <Label htmlFor="phone">Teléfono *</Label>
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  required
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="+56 9 1234 5678"
                />
              </div>

              <div className="form-group">
                <Label htmlFor="birthDate">Fecha de Nacimiento *</Label>
                <Input
                  id="birthDate"
                  name="birthDate"
                  type="date"
                  required
                  value={formData.birthDate}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <Label htmlFor="nationality">Nacionalidad *</Label>
                <Input
                  id="nationality"
                  name="nationality"
                  type="text"
                  required
                  value={formData.nationality}
                  onChange={handleInputChange}
                  placeholder="Tu nacionalidad"
                />
              </div>

              <div className="form-group">
                <Label htmlFor="currentClub">Club Actual</Label>
                <Input
                  id="currentClub"
                  name="currentClub"
                  type="text"
                  value={formData.currentClub}
                  onChange={handleInputChange}
                  placeholder="Club donde juegas actualmente"
                />
              </div>
            </div>

            <div className="form-group">
              <Label htmlFor="experience">Experiencia Profesional *</Label>
              <Textarea
                id="experience"
                name="experience"
                required
                value={formData.experience}
                onChange={handleInputChange}
                placeholder="Describe tu trayectoria como portero/a..."
                rows={4}
              />
            </div>

            <div className="form-group">
              <Label htmlFor="achievements">Logros Destacados</Label>
              <Textarea
                id="achievements"
                name="achievements"
                value={formData.achievements}
                onChange={handleInputChange}
                placeholder="Títulos, reconocimientos, hitos importantes..."
                rows={3}
              />
            </div>

            <div className="form-group">
              <Label htmlFor="objectives">Objetivos Profesionales *</Label>
              <Textarea
                id="objectives"
                name="objectives"
                required
                value={formData.objectives}
                onChange={handleInputChange}
                placeholder="¿Qué buscas alcanzar en tu carrera?"
                rows={4}
              />
            </div>

            <Button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
              size="lg"
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Enviando...
                </>
              ) : (
                <>
                  Enviar evaluación
                  <ArrowRight className="ml-2" />
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ApplicationSection;
